import { useState } from "react";

export function usePagination() {
  const [skip, setSkip] = useState<number>(1);

  return { skip, setSkip };
}
